import * as server from '../entries/pages/czynnosci-notarialne/_page.server.ts.js';

export const index = 7;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/czynnosci-notarialne/_page.svelte.js')).default;
export { server };
export const server_id = "src/routes/czynnosci-notarialne/+page.server.ts";
export const imports = ["_app/immutable/nodes/7.BjMCUxTl.js","_app/immutable/chunks/Cew_q46a.js","_app/immutable/chunks/DiR_Syld.js","_app/immutable/chunks/DHDEAeFQ.js","_app/immutable/chunks/Dh3qtgeV.js","_app/immutable/chunks/C5PKkLQu.js","_app/immutable/chunks/zAv0u1wk.js","_app/immutable/chunks/B6Ikv-5C.js","_app/immutable/chunks/Bu93Vllf.js"];
export const stylesheets = ["_app/immutable/assets/PageHeadingSection.CpMvHLMT.css"];
export const fonts = [];
